var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M224.113,218.529l9.107-5.245-9.107-5.245Zm0,0",
    transform: "translate(-199.6 -185.284)",
    fill: "#e93739"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M28,0A28,28,0,1,0,56,28,28,28,0,0,0,28,0ZM45.5,28.029a46.213,46.213,0,0,1-.72,8.417,4.384,4.384,0,0,1-3.084,3.084C38.953,40.25,28,40.25,28,40.25s-10.924,0-13.691-.749a4.385,4.385,0,0,1-3.084-3.084A46.01,46.01,0,0,1,10.5,28a46.183,46.183,0,0,1,.721-8.416,4.473,4.473,0,0,1,3.084-3.113C17.047,15.75,28,15.75,28,15.75s10.953,0,13.691.749a4.385,4.385,0,0,1,3.084,3.084C45.525,22.322,45.5,28.029,45.5,28.029Zm0,0",
    fill: "#e93739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d06ec67cfb8a6a626a229d2fcf2ebf6c.svg";
export { ForwardRef as ReactComponent };